/** HTML layers drawn over the world (the split-flap boards). A paused world draws no frames, so modals hide these directly. */
const overlays = new Set<HTMLElement>();
export function addWorldOverlay(root: HTMLElement) { overlays.add(root); }
export function removeWorldOverlay(root: HTMLElement) { overlays.delete(root); }
export function hideWorldOverlays(hidden: boolean) { for (const root of overlays) root.style.visibility = hidden ? 'hidden' : ''; }
